import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';

export function findInRouteTree<T>(
  route: ActivatedRoute,
  read: (snapshot: ActivatedRouteSnapshot) => T | null | undefined,
): T | null {
  let current: ActivatedRoute | null | undefined = route;
  while (current) {
    const value = read(current.snapshot);
    if (value !== null && value !== undefined) return value;
    current = current.parent;
  }
  return null;
}

// Ein leerer Parameter zählt als fehlend, damit die Suche eine Ebene höher weitergeht.
export function findRouteParam(route: ActivatedRoute, name: string): string | null {
  return findInRouteTree(route, (snapshot) => snapshot.paramMap.get(name) || null);
}
